// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image[data-v-cdf3f3e6]{cursor:pointer}.media[data-v-cdf3f3e6]{margin:0!important}.media[data-v-cdf3f3e6]:nth-child(2n){background:#fafafa}.search-description[data-v-cdf3f3e6]{margin-top:.5rem}.identifier-text[data-v-cdf3f3e6]{font-style:oblique}.widget-search-result-link[data-v-cdf3f3e6]:hover{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
